import { createReducer } from "redux-create-reducer";

import {
  GET_CLIENT_PROFILE_ENTRIES,
  GET_CLIENT_PROFILE_ENTRIES_COUNT,
  SET_CLIENT_PROFILE_ENTRY_SEARCH_FILTERS,
  CLEAR_CLIENT_PROFILE_ENTRIES,
  SET_CLIENT_PROFILE_ENTRY_CURRENT_PAGE,
  SET_ITEMS_PER_PAGE_CLIENT_PROFILE,
  SET_NO_ENTRIES_MESSAGE_CLIENT_PROFILE,
} from "../types";

const initialState = {
  data: [],
  pageInfo: {
    count: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  filters: {
    clientType: null,
    clientName: "",
    clientNumber: "",
  },
  entries: [],
  monitoringQueueEntries: [],
  isLoading: false,
  noEntriesMessage: "",
};

const clientProfileEntriesReducer = createReducer(initialState, {
  [SET_CLIENT_PROFILE_ENTRY_SEARCH_FILTERS]: (state, { payload }) => ({
    ...initialState,
    clientTypes: state.clientTypes,
    filters: { ...state.filters, ...payload },
  }),
  [SET_CLIENT_PROFILE_ENTRY_CURRENT_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      currentPage: payload,
    },
  }),
  [GET_CLIENT_PROFILE_ENTRIES_COUNT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_CLIENT_PROFILE_ENTRIES_COUNT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_CLIENT_PROFILE_ENTRIES_COUNT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_CLIENT_PROFILE_ENTRIES_COUNT.FULFILLED]: (state, { payload }) => {
    const hasResults = payload.data > 0;
    return {
      ...state,
      pageInfo: {
        ...state.pageInfo,
        count: payload.data,
      },
      isLoading: hasResults,
    };
  },
  [GET_CLIENT_PROFILE_ENTRIES.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_CLIENT_PROFILE_ENTRIES.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_CLIENT_PROFILE_ENTRIES.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_CLIENT_PROFILE_ENTRIES.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),

  [SET_ITEMS_PER_PAGE_CLIENT_PROFILE]: (state, { payload }) => ({
    ...state,
    pageInfo: { ...state.pageInfo, itemsPerPage: payload },
  }),
  [SET_NO_ENTRIES_MESSAGE_CLIENT_PROFILE]: (state, { payload }) => {
    return {
      ...state,
      noEntriesMessage: payload,
    };
  },
  [CLEAR_CLIENT_PROFILE_ENTRIES]: () => initialState,
});

export default clientProfileEntriesReducer;



// WEBPACK FOOTER //
// ./src/features/client-profile/reducers/clientProfileEntriesReducer.js